(function () {
  'use strict';
  if (window.PrismFlightCenterI18n) return;
  var element = document.getElementById('PrismFcLocalizationConfig');
  var config = element ? JSON.parse(element.textContent) : {};
  var languages = new Set((config.languages || []).map(function (code) { return code.toLowerCase(); }));
  var root = (config.root || '/').replace(/\/$/, '');
  var preview = new URLSearchParams(location.search).get('preview_theme_id');

  function text(key, fallback, parameters) {
    var result = (config.labels || {})[key] || fallback;
    Object.keys(parameters || {}).forEach(function (name) {
      result = result.split('__' + name.toUpperCase() + '__').join(String(parameters[name]));
    });
    return result;
  }

  function localUrl(value) {
    if (!value || value.charAt(0) === '#') return value;
    try {
      var url = new URL(value, location.href);
      if (url.origin !== location.origin || !['http:', 'https:'].includes(url.protocol)) return value;
      var segments = url.pathname.split('/').filter(Boolean);
      if (languages.has((segments[0] || '').toLowerCase())) segments.shift();
      // Resource handles remain unchanged. Leave CDN files and app endpoints alone.
      if (!['pages', 'collections', 'products', 'search'].includes(segments[0])) return value;
      url.pathname = root + '/' + segments.join('/') + (url.pathname.endsWith('/') ? '/' : '');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      return url.href;
    } catch (_) { return value; }
  }

  function normalize(value) {
    return (value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase().replace(/ł/g, 'l').replace(/œ/g, 'oe').replace(/æ/g, 'ae')
      .replace(/ß/g, 'ss').replace(/[^a-z0-9]/g, '');
  }

  window.PrismFlightCenterI18n = { text: text, localUrl: localUrl, normalize: normalize };
  function refreshLinks(scope) {
    scope.querySelectorAll('.prism-fc-section a[href]').forEach(function (link) {
      var original = link.getAttribute('href');
      var localized = localUrl(original);
      if (localized !== original) link.setAttribute('href', localized);
    });
  }
  function initialize() {
    refreshLinks(document);
    var form = document.getElementById('PrismFcLanguageForm');
    if (form) form.addEventListener('submit', function () {
      var returnTo = form.querySelector('[name="return_to"]');
      if (returnTo) returnTo.value = location.pathname + location.search + location.hash;
    });
    var main = document.getElementById('MainContent');
    if (main && window.MutationObserver) {
      // Translate links from section editor refreshes and asynchronous directory results.
      new MutationObserver(function () { refreshLinks(main); })
        .observe(main, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
